import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { Radio, Modal as AntModal, PageHeader } from "antd";
import About from "./About";
import Panel from "./Panel";
import { Team } from "shared/interfaces/Team";
import { fetchLoggedUserTeams } from "shared/service/StrmService";
import "./Diagnostic.scss";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";

const { success, error } = AntModal;
const Diagnostic: React.FC<RouteComponentProps> = (props) => {
  const { history, location } = props;
  const { t } = useTranslation("radar");
  const [selectedTab, setSelectedTab] = useState<string>("about");
  const [team, setTeam] = useState<Team>();

  const getTeams = useCallback(async () => {
    const response: any = await fetchLoggedUserTeams();
    setTeam(response);
  }, []);

  useEffect(() => {
    getTeams();

    const state: any = location.state;
    if (state?.success) {
      success({
        title: t("pages.Diagnostic.modalDiagnoseSuccessTitle"),
        content: t("pages.Diagnostic.modalDiagnoseSuccessContent"),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-verde",
          style: { padding: 0 },
        },
        okType: "link",
        onOk() {
          console.log("ok");
        },
      });
    }
    if (state?.error) {
      error({
        title: t("pages.Diagnostic.modalDiagnoseErrorTitle"),
        content: t("pages.Diagnostic.modalDiagnoseErrorContent"),
        icon: "",
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        okButtonProps: {
          className: "botao-vermelho",
          style: { padding: 0 },
        },
        okType: "link",
      });
    }
  }, [location, t, getTeams]);

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Assessment.S4L_ARTIST_ASSESSMENT,
    });
  }, []);

  const RadioButtonsSelectTab = () => (
    <Radio.Group
      value={selectedTab}
      onChange={(e) => setSelectedTab(e.target.value)}
    >
      <Radio.Button value="about">{t("pages.Diagnostic.about")}</Radio.Button>
      <Radio.Button value="panel">{t("pages.Diagnostic.panel")}</Radio.Button>
    </Radio.Group>
  );

  return (
    <div className="diagnostic">
      <div className={`content ${selectedTab === "about" && "bg-image"}`} />
      <RadioButtonsSelectTab />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          padding: "0px 110px 110px 110px",
        }}
      >
        <PageHeader
          title={t("pages.Diagnostic.title")}
          subTitle={t("pages.Diagnostic.subTitle")}
          className="vertical"
        />
        {selectedTab === "about" && (
          <About getTeams={getTeams} history={history} team={team} />
        )}
        {selectedTab === "panel" && <Panel team={team} getTeams={getTeams} />}
      </div>
    </div>
  );
};

export default Diagnostic;
